(function () {

  // ---------------------------------------------------------------------------
  // Slide geometry — must match CSS values exactly
  // ---------------------------------------------------------------------------
  const SLIDE = {
    width:         250,  // .carousel__slide width (px)
    widthSelected: 331,  // .carousel__slide--selected width (px)
    gap:            15,  // gap between slides (px)
    widthMobile:         180,
    widthSelectedMobile: 250,
    gapMobile:           15,
    breakpoint:         750,  // px — below this = mobile values
  };

  // Transition config
  const TRANSITION_MS      = 420;
  const TRANSITION_EASING  = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';
  const SWIPE_THRESHOLD    = 40;
  const DRAG_THRESHOLD     = 5;

  // ---------------------------------------------------------------------------

  function initCarousel(carousel) {
    const track = carousel.querySelector('.carousel__track');
    if (!track) return;

    const body = carousel.querySelector('.carousel__body');

    // Clone original Liquid-rendered slides to fill the track.
    // Done in JS (not Liquid) so each block is only registered once by Shopify.    
    const CLONE_GROUPS = 5;
    const originalSlides = Array.from(track.querySelectorAll('.carousel__slide'));
    if (!originalSlides.length || !body) return;

    const fragment = document.createDocumentFragment();
    for (let i = 1; i < CLONE_GROUPS; i++) {
      originalSlides.forEach(slide => {
        const clone = slide.cloneNode(true);
        clone.removeAttribute('id');
        clone.removeAttribute('data-shopify-editor-block');
        // Defer image loading on clones — src is restored as slides come into range
        clone.querySelectorAll('img').forEach(img => {
         if (img.src)    { img.dataset.src    = img.src;    img.removeAttribute('src'); }
         if (img.srcset) { img.dataset.srcset = img.srcset; img.removeAttribute('srcset'); }
       });
       fragment.appendChild(clone);
       });
    }
    track.appendChild(fragment);

    const slides     = Array.from(track.querySelectorAll('.carousel__slide'));    
    const totalSlides  = slides.length;
    const groupSize    = Math.round(totalSlides / CLONE_GROUPS);

    const prevBtn = carousel.querySelector('[data-action="previous"], .slideshow-control--previous');
    const nextBtn = carousel.querySelector('[data-action="next"], .slideshow-control--next');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    let currentIndex = Math.floor(CLONE_GROUPS / 2) * groupSize + Math.floor(groupSize / 2);

    let targetTranslate = 0;
    let isAnimating     = false;

    // -------------------------------------------------------------------------
    // Geometry helpers
    // -------------------------------------------------------------------------

    function isMobile() {
      return window.innerWidth < SLIDE.breakpoint;
    }

    function getSlideWidth(selected) {
      return isMobile()
        ? (selected ? SLIDE.widthSelectedMobile : SLIDE.widthMobile)
        : (selected ? SLIDE.widthSelected       : SLIDE.width);
    }

    function getGap() {
      return isMobile() ? SLIDE.gapMobile : SLIDE.gap;
    }

    function calculateTranslate(targetIdx) {
      const bodyWidth  = body.getBoundingClientRect().width;
      const bodyCenter = bodyWidth / 2;
      const gap        = getGap();

      let x = 0;
      const positions = slides.map((_, i) => {
        const left = x;
        x += getSlideWidth(i === targetIdx) + gap;
        return left;
      });

      const slideLeft   = positions[targetIdx];
      const slideCenter = slideLeft + getSlideWidth(true) / 2;

      return bodyCenter - slideCenter;
    }

    // -------------------------------------------------------------------------
    // Navigation
    // -------------------------------------------------------------------------

    function goTo(index) {
      const min = groupSize;
      const max = totalSlides - groupSize - 1;

      if (index < min) {
        const mirror = max - (groupSize - index % groupSize);
        currentIndex = mirror;
        applyTranslate(calculateTranslate(mirror), true);
        requestAnimationFrame(() => goTo(mirror - 1));
        return;
      }

      if (index > max) {
        const mirror = min + (index % groupSize);
        currentIndex = mirror;
        applyTranslate(calculateTranslate(mirror), true);
        requestAnimationFrame(() => goTo(mirror + 1));
        return;
      }

      currentIndex = index;
      render(false);
    }

    // -------------------------------------------------------------------------
    // Render
    // -------------------------------------------------------------------------

    function loadNearbyImages(center, radius) {
      const start = Math.max(0, center - radius);
      const end   = Math.min(totalSlides - 1, center + radius);
      for (let i = start; i <= end; i++) {
        slides[i].querySelectorAll('img[data-src]').forEach(img => {
          img.src = img.dataset.src;
          if (img.dataset.srcset) img.srcset = img.dataset.srcset;
          delete img.dataset.src;
          delete img.dataset.srcset;
        });
      }
    }

    function render(instant) {
      slides.forEach((s, i) => {
        s.classList.toggle('carousel__slide--selected', i === currentIndex);

        // Load iframes within 2 slides of current, unload the rest
        const iframe = s.querySelector('iframe[data-src]');
        const loaded = s.querySelector('iframe[src]:not([data-src])');

        if (Math.abs(i - currentIndex) <= 2) {
          if (iframe) {
            iframe.src = iframe.dataset.src;
            iframe.removeAttribute('data-src');
          }
        } else {
          if (loaded) {
            loaded.dataset.src = loaded.src;
            loaded.removeAttribute('src');
          }
        }
      });

      const translate = calculateTranslate(currentIndex);
      applyTranslate(translate, instant || reducedMotion.matches);
      loadNearbyImages(currentIndex, 5);
    }

    function applyTranslate(translate, instant) {
      targetTranslate = translate;

      if (instant) {
        track.style.willChange = 'auto';
        track.style.transition = 'none';
        track.getBoundingClientRect();
        track.style.transform = `translateX(${translate}px)`;
        track._translateX = translate;
        isAnimating = false;
        return;
      }

      isAnimating = true;
      track.style.willChange = 'transform';
      track.style.transition = `transform ${TRANSITION_MS}ms ${TRANSITION_EASING}`;
      track.style.transform  = `translateX(${translate}px)`;
      track._translateX      = translate;

      clearTimeout(track._animTimeout);
      track._animTimeout = setTimeout(() => {
        isAnimating = false;
        track.style.willChange = 'auto';
      }, TRANSITION_MS + 20);
    }

    // -------------------------------------------------------------------------
    // Drag / swipe
    // -------------------------------------------------------------------------

    let dragStartX         = null;
    let dragStartTranslate = null;
    let isDragging         = false;
    let didDrag            = false;

    track.addEventListener('pointerdown', (e) => {
      // Don't interfere with the play/pause button
      if (e.target.closest('.video-play-toggle')) return;

      // Don't interfere with links — let them handle their own clicks
      if (e.target.closest('a')) return;

      const matrix = new DOMMatrix(getComputedStyle(track).transform);
      dragStartTranslate = matrix.m41;

      dragStartX = e.clientX;
      isDragging = false;
      didDrag    = false;

      // NOTE: No setPointerCapture — that was hijacking clicks on child links
      track.style.transition = 'none';
      track.style.transform  = `translateX(${dragStartTranslate}px)`;
      track._translateX      = dragStartTranslate;
      isAnimating = false;
    });

    track.addEventListener('pointermove', (e) => {
      if (dragStartX === null) return;
      const dx = e.clientX - dragStartX;

      if (!isDragging && Math.abs(dx) > DRAG_THRESHOLD) {
        isDragging = true;
        didDrag    = true;
        track.classList.add('is-dragging');
      }

      if (isDragging) {
        const x = dragStartTranslate + dx;
        track.style.transform = `translateX(${x}px)`;
        track._translateX = x;
      }
    });

    track.addEventListener('pointerup', (e) => {
      if (dragStartX === null) return;
      const dx = e.clientX - dragStartX;
      track.classList.remove('is-dragging');
      dragStartX = null;

      const wasDragging = isDragging;
      isDragging = false;

      if (!wasDragging) return;

      if (dx < -SWIPE_THRESHOLD) {
        goTo(currentIndex + 1);
      } else if (dx > SWIPE_THRESHOLD) {
        goTo(currentIndex - 1);
      } else {
        render(false);
      }
    });

    track.addEventListener('pointercancel', () => {
      track.classList.remove('is-dragging');
      dragStartX = null;
      isDragging = false;
      render(false);
    });

    // Block click propagation only after a real drag
    track.addEventListener('click', (e) => {
      if (didDrag) {
        e.stopPropagation();
        e.preventDefault();
        didDrag = false;
      }
    }, true);

    // -------------------------------------------------------------------------
    // Button controls
    // -------------------------------------------------------------------------

    prevBtn?.addEventListener('click', () => goTo(currentIndex - 1));
    nextBtn?.addEventListener('click', () => goTo(currentIndex + 1));

    // -------------------------------------------------------------------------
    // Keyboard
    // -------------------------------------------------------------------------

    carousel.setAttribute('tabindex', '0');
    carousel.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); goTo(currentIndex - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(currentIndex + 1); }
    });

    // -------------------------------------------------------------------------
    // Resize
    // -------------------------------------------------------------------------

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => render(true), 100);
    });

    // -------------------------------------------------------------------------
    // Reduced motion
    // -------------------------------------------------------------------------

    reducedMotion.addEventListener('change', () => render(reducedMotion.matches));

    // -------------------------------------------------------------------------
    // Init
    // -------------------------------------------------------------------------

    render(true);
  }

  // ---------------------------------------------------------------------------
  // Bootstrap
  // ---------------------------------------------------------------------------

  function initAll() {
    document.querySelectorAll('.carousel').forEach(carousel => {
      if (carousel._carouselInit) return;
      carousel._carouselInit = true;
      initCarousel(carousel);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('.carousel').forEach(c => delete c._carouselInit);
    initAll();
  });

})();
